import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_LOCALE,
  STORAGE_KEY,
  isEnabled,
  isPrefix,
  browserMatch,
} from "./helpers";

// Auto-load every locale JSON present in ./locales (webpack require.context),
// so adding a language only needs a new JSON file + a config entry.
const ctx = require.context("./locales", false, /\.json$/);
const resources = {};
ctx.keys().forEach((key) => {
  const code = key.replace("./", "").replace(".json", "");
  resources[code] = { translation: ctx(key) };
});

function detectInitial() {
  try {
    const segs = window.location.pathname.split("/").filter(Boolean);
    if (segs[0] && isPrefix(segs[0])) return segs[0];
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && isEnabled(stored)) return stored;
    const bm = browserMatch();
    if (bm) return bm;
  } catch (e) {
    /* ignore */
  }
  return DEFAULT_LOCALE;
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectInitial(),
  fallbackLng: DEFAULT_LOCALE,
  returnEmptyString: false, // empty values fall back to the default language
  returnNull: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
